<template>
  <v-container class="py-7">
    <v-row>
      <v-col :cols="12">
        <div class="title-container">
          <div class="title-block">
            <span id="title" class="page-title">Privacidade</span>
            <v-breadcrumbs
              class="app-breadcrumb"
              divider="›"
              :items="[
                {
                  text: 'Homepage',
                  disabled: false,
                  to: '/home',
                  exact: true
                },
                {
                  text: 'Políticas de Privacidade',
                  disabled: true,
                  exact: true
                }
              ]"
            ></v-breadcrumbs>
          </div>
          <div class="button-group" style="padding-right: 16px">
            <v-btn
              :disabled="!$check(user, ['privacy.create'])"
              id="btnNew"
              type="button"
              color="primary"
              elevation="0"
              to="/privacidade/novo"
              >Incluir</v-btn
            >
          </div>
        </div>
      </v-col>
    </v-row>
    <!-- <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name" hide-details
                                        outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2"
                                        >Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
    <v-row>
      <v-col cols="12">
        <v-card class="table-card">
          <v-card-title class="filter-card-title">Filtros</v-card-title>
          <v-form @submit.prevent="load()">
            <v-card-text>
              <v-row>
                <v-col cols="auto" sm="3">
                  <v-select
                    style="padding-left: 4px"
                    dense
                    id="user_type"
                    :items="dataset.userType"
                    label="Tipo"
                    v-model="dataList.filter.user_type"
                    item-value="id"
                    item-text="name"
                    outlined
                    hide-details="auto"
                    @change="load"
                    no-data-text="Nenhuma informação disponível"
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider class="mt-2"></v-divider>

            <v-container>
              <v-row class="mt-3">
                <v-col cols="4" align-self="baseline">
                  <v-text-field
                    style="padding-left: 8px"
                    dense
                    label="Procurar"
                    v-model="dataList.filter.content"
                    hide-details
                    outlined
                    clearable
                    @click:clear="clearNameSearch"
                  >
                  </v-text-field>
                </v-col>

                <v-spacer></v-spacer>

                <v-col v-if="hasFilters()" cols="auto" style="padding-right: 1px">
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn
                        v-on="on"
                        id="btnClearFilter"
                        type="button"
                        outlined
                        color="primary"
                        @click="clearFilters"
                      >
                        Limpar</v-btn
                      >
                    </template>
                    <span>Limpar filtros de busca selecionados</span>
                  </v-tooltip>
                </v-col>

                <v-col cols="auto" style="padding-right: 16px">
                  <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2"
                    >Filtrar</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-form>

          <v-card-title class="table-card-title">Políticas</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="dataList.headers"
              :items="dataList.data"
              :server-items-length="dataList.count"
              @update:items-per-page="pageSizeChanged"
              @update:page="pageChanged"
              :disable-sort="true"
              :loading="dataList.loading"
              no-data-text="Nenhuma política foi encontrada"
              loading-text="Carregando dados..."
              class="app-table hover-table"
              :options.sync="dataList.options"
              :footer-props="dataList.footerOptions"
            >
              <template v-slot:[`item.version`]="{ item }">
                <v-tooltip bottom v-if="isActive(item)">
                  <template #activator="{ on }">
                    <v-icon v-on="on" color="success" class="ml-1" small> mdi-check-circle </v-icon>
                  </template>
                  <span
                    >Esta é a versão mais recente e vigente desta política</span
                  >
                </v-tooltip>
                <span class="ml-2">{{ item.version }}</span>
              </template>

              <template v-slot:[`item.privacy_type`]="{ item }">
                <v-chip
                  small
                  class="text-uppercase font-weight-bold text-caption"
                  label
                 
                >
                {{ getPrivacyTypeLabel(item.privacy_type) }}
                </v-chip>
              </template>

              <template v-slot:[`item.user_type`]="{ item }">
                <v-chip
                  small
                  class="text-uppercase font-weight-bold text-caption"
                  :color="getChipColor(item)"
                  label
                  text-color="white"
                >
                  {{ getChipLabel(item) }}
                </v-chip>
              </template>

              <template v-slot:[`item.status`]="{ item }">
                <v-chip
                  small
                  class="text-uppercase font-weight-bold text-caption"
                  :color="item.status == 1 ? 'success' : 'error'"
                  label
                  text-color="white"
                >
                  {{ item.status == 1 ? 'ATIVO' : 'INATIVO' }}
                </v-chip>
              </template>

              <template v-slot:[`item.created_at`]="{ item }">
                {{ item.created_at | defaultDate('DD/MM/YYYY HH:mm:ss') }}
              </template>

              <template v-slot:[`item.expires_at`]="{ item }">
                {{ item.expires_at | defaultDate("DD/MM/YYYY") }}
              </template>


              <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                  :disabled="!$check(user, ['privacy.find'])"
                  @click="viewItem(item)"
                  size="large"
                  class="me-2"
                >
                  mdi-eye-outline
                </v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue'
import VueLodash from 'vue-lodash'
import _ from 'lodash'
import axios from 'axios'

import object from '@/common/util/object'

import userType from '@/common/data/term-user-type.data'
import privacyTypes from '@/common/data/privacy-types.data'

Vue.use(VueLodash)

export default {
  name: 'PrivacyList',

  data: () => ({
    user: null,
    dataset: {
      userType: [{ id: '', name: 'Todos' }, ...userType],
      privacyTypes: privacyTypes,
      data: {},
      type: []
    },
    dataList: {
      filter: {
        content: '',
        user_type: '',
        // client: "",
        unit: ''
        // status: ""
      },
      headers: [
        { text: 'Versão', value: 'version' },
        { text: 'Tipo', value: 'privacy_type' },
        { text: 'Usuário', value: 'user_type' },
        { text: 'Status', value: 'status' },
        { text: 'Criado em', value: 'created_at', sortable: true },
        { text: 'Expira em', value: 'expires_at'},
        { text: 'Ações', value: 'actions', sortable: false }
      ],
      data: [],
      loading: false,
      count: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['created_at'],
        sortDesc: [true]
      },
      footerOptions: {
        itemsPerPageText: 'Itens por página:',
        itemsPerPageOptions: [10, 20, 30, 40, 50],
        pageText: '{0}-{1} de {2}'
      }
    }
  }),

  created() {
    this.load()
  },

  methods: {
    pageChanged(page) {
      this.dataList.options.page = page
      this.load()
    },

    pageSizeChanged(size) {
      this.dataList.options.itemsPerPage = size
      this.load(true)
    },

    hasFilters() {
      return Object.values(this.dataList.filter).some((value) => value !== '')
    },

    clearFilters() {
      Object.keys(this.dataList.filter).forEach((key) => {
        this.dataList.filter[key] = ''
      })
      this.load()
    },

    clearNameSearch() {
      this.dataList.filter.content = ''
      this.load()
    },

    debounce: _.debounce(function () {
      this.reload()
    }, 500),

    reload: function () {
      this.load()
    },

    isActive(item) {
      return item.status === 1 || item.status === true
    },

    getChipColor(item) {
      if (item.user_type == 1) {
        return '#1E90FF'
      }

      if (item.user_type == 2) {
        return '#5A32A3'
      }

      if (item.user_type == 3) {
        return '#DAA520'
      }

      if (item.user_type == 4) {
        return '#00BCD4'
      }
    },

    getChipLabel(item) {
      return this.enum(item.user_type, this.dataset.userType, 'id', 'name')
    },

    getPrivacyTypeLabel(privacyTypeId) {
      const matchedPrivacy = this.dataset.privacyTypes.find(type => type.id === privacyTypeId);
      return matchedPrivacy ? matchedPrivacy.name : 'Desconhecido';
    },

    getTypeLabel(id) {
      const matchedType = this.dataset.userType.find((type) => type.id === id)
      return matchedType ? matchedType.name : 'Desconhecido'
    },

    enum(id, userType, idKey, nameKey) {
      const matchedStatus = userType.find((e) => e[idKey] === id)
      return matchedStatus ? matchedStatus[nameKey] : 'Desconhecido'
    },

    async load() {
      this.user = this.$root.user.data || this.$root.user

      // Filtrar os campos preenchidos nos filtros
      let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))
      search = !object.isEmpty(search) ? search : null

      this.dataList.loading = true

      // Itens por página e ordenação
      const { itemsPerPage, page, sortBy, sortDesc } = this.dataList.options
      const limit = itemsPerPage
      const sortField = sortBy[0] || 'created_at' // Campo de ordenação padrão
      const sortOrder = sortDesc[0] ? 'desc' : 'asc' // Ordem padrão: desc

      try {
        // Faz a chamada ao endpoint com as opções de paginação e ordenação
        const result = await axios.get('/api/terms', {
          params: {
            page,
            limit,
            search,
            sortBy: sortField,
            order: sortOrder
          }
        })

        // Atualiza os dados da tabela
        this.dataList.data = result.data.content.data
        this.dataList.count = result.data.content.paging.total

        const userType = Array.isArray(result.data.content.data.user_type)
          ? result.data.content.data.user_type
          : []
        this.dataset.type = [{ id: '', user_type: 'Todos' }, ...userType]

      } catch (error) {
        // Trata erros com uma notificação amigável
        this.$dialog.notify.error(
          'Erro ao carregar os dados. Verifique sua conexão ou tente novamente mais tarde.',
          {
            position: 'top-right',
            timeout: 5000
          }
        )
        console.error('Erro no carregamento de dados:', error)
      } finally {
        this.dataList.loading = false
      }
    },

    viewItem(item) {
      this.$router.push(`privacidade/${item.id}`)
    }
  }
}
</script>